export const saveState = state => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('best-practices', serializedState);
  } catch (e) {
    console.log('Could not save state');
  }
};

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('best-practices');
    if (!serializedState) {
      return undefined;
    }

    return {...JSON.parse(serializedState)};
  } catch (e) {
    return undefined;
  }
};
